import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-you",
  "use": "icon-you-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-you\">\n<g clip-path=\"url(#icon-you_clip0_260_7647)\">\n<path d=\"M5 15L12 8L5 1\" stroke=\"#999999\" stroke-width=\"1.4\" stroke-linecap=\"round\" />\n</g>\n<defs>\n<clipPath id=\"icon-you_clip0_260_7647\">\n<rect width=\"16\" height=\"16\" fill=\"white\" transform=\"matrix(0 -1 1 0 0 16)\" />\n</clipPath>\n</defs>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol